import type { BraintreePayPalCheckout } from '@paypal/react-paypal-js/dist/types/types/braintree/paypalCheckout';

type CreateOrderParams = {
	amount?: number;
	currency: string;
	paypalCheckout: BraintreePayPalCheckout | null;
};

export async function createOrder({ amount, currency, paypalCheckout }: CreateOrderParams): Promise<string> {
	if (!paypalCheckout) {
		return Promise.reject(new Error('No paypal checkout instance'));
	}

	return paypalCheckout.createPayment({
		amount,
		currency,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		flow: 'checkout' as paypal.FlowType.Checkout,
	});
}
